export const isClient = typeof window === "object"

export const formatSensaiUrl = (url: string) => {
  const isSensai = url && (url as String).startsWith("https://sens.ai")
  let formatedUrl = isSensai || url.indexOf("/") === 0 ? url : `/${url}`
  formatedUrl =
    formatedUrl === "/" || formatedUrl.endsWith("/")
      ? formatedUrl
      : `${formatedUrl}/`
  return formatedUrl
}

export const cleanSlug = (slug: string, isPage = false) => {
  if (!slug || slug === "") {
    return isPage ? "/" : ""
  }
  if (!slug.includes(".")) {
    slug = slug.toLowerCase()
  }
  if (slug.length > 1 && slug.endsWith("/")) {
    //trim off trailing slash
    slug = `${slug.slice(0, slug.length - 1)}`
  }
  if (slug.startsWith("#")) {
    //relative anchor link
    return slug
  }

  return slug.startsWith("/") || slug.startsWith("http")
    ? `${slug}`
    : `/${slug}`
}

export const formatDate = ({
  date,
  fullMonth,
}: {
  date: Date
  fullMonth: boolean
}): string => {
  const dateStr = new Intl.DateTimeFormat("en", {
    month: fullMonth ? "long" : "short",
    day: "2-digit",
    year: "numeric",
  }).format(date)
  return dateStr
}

export const formatCurrencyString = (
  {
    value,
    currency,
  }: {
    value: number
    currency: string
  },
  renderDollar = true,
  showCurrency = true
) => {
  const language = currency === "CAD" ? "en-CA" : "en-US"

  const numberFormat = new Intl.NumberFormat(language, {
    style: showCurrency ? "currency" : "decimal",
    currency,
    currencyDisplay: showCurrency ? "symbol" : "code",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  const parts = numberFormat.formatToParts(value)
  let zeroDecimalCurrency = true

  for (let i = 0; i < parts.length; i += 1) {
    const part = parts[i]
    if (part.type === "decimal") {
      zeroDecimalCurrency = false
      break
    }
  }

  let val = zeroDecimalCurrency ? value : value / 100

  if (!renderDollar) {
    return numberFormat
      .format(parseFloat(val.toFixed(2)))
      .replace(/\D00(?=\D*$)/, "")
      .replace("$", "")
  }
  if (!showCurrency && renderDollar) {
    return (
      "$" +
      numberFormat
        .format(parseFloat(val.toFixed(2)))
        .replace(/\D00(?=\D*$)/, "")
    )
  }

  return numberFormat
    .format(parseFloat(val.toFixed(2)))
    .replace(/\D00(?=\D*$)/, "")
}

export const getRandomNum = (min: number, max: number): number => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

const EU_COUNTRIES = [
  "DNK",
  "Denmark",
  "EST",
  "Estonia",
  "FIN",
  "Finland",
  "FRA",
  "France",
  "DEU",
  "Germany",
  "GRC",
  "Greece",
  "HUN",
  "Hungary",
  "IRL",
  "Ireland",
  "ITA",
  "LVA",
  "Latvia",
  "LTU",
  "Lithuania",
  "LUX",
  "Luxembourg",
  "MLT",
  "Malta",
  "NLD",
  "Netherlands",
  "POL",
  "Poland",
  "PRT",
  "Portugal",
  "ROU",
  "Romania",
  "SVK",
  "Slovakia",
  "SVN",
  "Slovenia",
  "ESP",
  "Spain",
  "SWE",
  "Sweden",
]
export const isInEU = (countryCode: string) =>
  EU_COUNTRIES.indexOf(countryCode) !== -1
